
<style>
  .ctn {
  }

  .macro {
    width: 276px;
  }
  .macro .ve-pop-body {
    max-height: 350px;
    overflow: auto;
  }
  .macro .ve-input {
  }
  .macro .wrap li {
    cursor: pointer;
    padding: 6px;
  }
  .macro .wrap li:hover {
      background: rgba(0, 0, 0, 0.04);
  }
  .ve-btn {
      border: 1px solid #ccc;
      color: #333;
  }
  .ve-btn:hover {
      border: 1px solid #ccc;
      color: #333;
      background: rgba(0, 0, 0, 0.04);
  }
  .ve-divider {
    display: block;
    flex: 1 1 0px;
    max-width: 100%;
    height: 0px;
    max-height: 0px;
    border: solid;
    border-width: thin 0 0 0;
    transition: inherit;
    border-color: rgba(0, 0, 0, 0.12);
    padding: 0px !important;
  }

  /*icon for toolbar button*/
  .icon-macro {
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA4UlEQVRYw+2WMQ6DMAxFv0TFBdgQ3I2KEe7HzAISAg7CyAXSobSQKpUdihFS/TMm5iXxdzCgUqncClGiwQyzGZ/azs1oUCLkfj7GaIXTgOcYEfN2PziCOQCDgXOKwhnKAxgUNKBdllZI2DlLUC1RLb34ldrUyxbpO92kvl3JYXEKYCZr8gZMHHOsdqu9ATVlb7tgMm9ARhSmNdkh8AYE6LiAHtGuNzhCzwHkO3a/niK/AOCXKxokk3yzMmCOt+mdsql4oZ3yVOhzfQ2A+E9fvG0Rb7zEW0fx5veE9l2l+jc9AKkzhtUre6odAAAAAElFTkSuQmCC") no-repeat;
  }
</style>

<template>
  <div class="ve-popover macro" v-show="showPopup"
  :style="style">
    <div v-show="!val">
      <div class="ve-pop-header">Макрос</div>
      <div class="ve-pop-body">
        <div class="wrap">
          <ul>
            <li v-for="item in arr" @click="addItem(item)">{{item.title}}</li>
            <li class="ve-divider"></li>
            <li @click="check()">Проверить</li>
            <li @click="copyForTemplate()">Копировать для шаблона</li>
            <li @click="updatePopupDisplay()">Отмена</li>
            <li class="ve-divider"></li>
            <li v-show="!fullscreen" @click="toFullScreen()">Полный экран</li>
          </ul>
        </div>
      </div>
    </div>
    <div v-show="val">
      <div class="ve-pop-header">Изменить макрос</div>
      <div class="ve-pop-body">
        <input class="ve-input" v-model="text"></v-textarea>
        <v-textarea rows="5" v-model="newVal"></v-textarea>
        <button type="button" class="ve-btn" @click="updateMacro">Сохранить</button>
        <button type="button" class="ve-btn" @click="updatePopupDisplay">Отменить</button>
  </div>
    </div>
  </div>
</template>

<script>
import store from '../../store'
import formats from '../../api/formats'
export default {
  data () {
    return {
      val: '',
      newVal: '',
      text: '',
      arr: [
        {title: 'Значение', templates: ['<xsl:value-of select="" />'], hint: ''},
        {title: 'Начало блока', templates: ['<xsl:for-each select="" >'], hint: ''},
        {title: 'Конец блока', templates: ['</xsl:for-each>'], hint: ''}
        // ,
        // {title: 'Условие', templates: ['<xsl:if test="">', '</xsl:if>'], hint: ''}
      ]
    }
  },
  watch: {
    'showPopup': function (val) {
      val && this.setVal()
    }
  },
  computed: {
    rect: function () {
      return this.$store.state.rect
    },
    range: function () {
      return this.$store.state.range
    },
    style: function () {
      if (!this.showPopup) {
        return {left: 0, top: 0}
      }
      let {left, top, width, height} = this.rect
      let offsetLeft = left
      let offsetTop = top
      if (this.$el) {
        this.$el.style.display = 'block'
        // > 0 means the popover menu's right part is not totally visible
        if (left + this.$el.offsetWidth - this.$el.parentElement.clientWidth > 0) {
          offsetLeft = left - this.$el.offsetWidth + width
          if (offsetLeft < 0) {
            offsetLeft = left + width / 2 - this.$el.offsetWidth / 2
          }
        }
        if (top + this.$el.offsetHeight - this.$el.parentElement.clientHeight > 0) {
          offsetTop = top - this.$el.offsetHeight + height
          if (offsetTop < 0) {
            offsetTop = top + height / 2 - this.$el.offsetHeight / 2
            offsetLeft += left > offsetLeft ? -width : width
          }
        }
        this.$el.style.display = 'none'
      }
      return {left: offsetLeft + 'px', top: offsetTop + 'px'}
    },
    showPopup: function () {
      return this.$store.state.toolbar.macro.showPopup
    },
    fullscreen: function () {
      return this.$store.state.fullscreen
    }
  },
  methods: {
    setVal () {
      this.val = null
      if (this.range) {
        let container = this.range.commonAncestorContainer
        container.nodeType === 3 && (container = container.parentNode)
        container && container.nodeName === 'A' && container.href &&
        (this.val = container.getAttribute('href').replace('xslt:', '')) &&
        (this.text = container.innerText) && (this.newVal = this.val)
      }
    },
    updatePopupDisplay () {
      this.$store.dispatch('updatePopupDisplay')
    },
    // insertItem (item) {
    //   console.log('insertItem', item)
    //   if (item.templates) {
    //     let main = document.createElement('span')
    //     item.templates.forEach(template => {
    //       let div = this.createMacro(this.range && this.range.extractContents().textContent || item.title, template)
    //       main.appendChild(div)
    //     })
    //     this.$store.dispatch('execCommand', {name: 'insertHTML', value: main.innerHTML})
    //     this.updatePopupDisplay()
    //   }
    // },
    createMacro (text, value) {
      let div = document.createElement('a')
      if (value) {
        div.setAttribute('href', `xslt:${value}`)
      }
      div.innerText = text || value
      return div
    },
    insertMacro (text, value) {
      let outerHTML = text
      if (value) {
        let div = this.createMacro(text, value)
        outerHTML = div.outerHTML
      }
      this.$store.dispatch('execCommand', {name: 'insertHTML', value: outerHTML})
      this.updatePopupDisplay()
    },
    addItem (item) {
      this.newVal = item.templates
      this.val = this.newVal
      this.text = this.range && this.range.cloneContents().textContent || item.title
    },
    updateMacro () {
      this.$store.dispatch('execCommand', {name: 'unlink', value: null})
      setTimeout(() => {
        this.insertMacro(this.text, this.newVal)
      }, 200)
    },
    copyForTemplate () {
      let content = this.$store.state.content
      store.dispatch('copyToClipboard', {text: `<![CDATA[${content}]]>`})
      this.updatePopupDisplay()
    },
    toFullScreen () {
      this.$store.dispatch('setFullScreen', !this.fullscreen)
      this.updatePopupDisplay()
    },
    check () {
      console.log('check', formats.getValue(this, ['$parent', '$el', 'parentNode', 'parentNode']))
      let content = this.$store.state.content
      let htmlField = formats.getValue(this, ['$parent', '$el', 'parentNode', 'parentNode', 'parentNode', '__vue__'])
      htmlField && htmlField.$emit('check', content)
      this.updatePopupDisplay()
    }
  }
}
</script>



// WEBPACK FOOTER //
// macro.vue?332f294b